import React, { forwardRef, ReactNode } from 'react';

import { IconButtonWrapper } from './styled';

interface IconButtonProps {
  ariaLabel: string;
  children: ReactNode;
  handleClick: (e: React.MouseEvent) => void;
  color: string;
}

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ ariaLabel, handleClick, color, children }, ref) => (
    <IconButtonWrapper
      ref={ref}
      onClick={(e) => {
        e.stopPropagation();
        handleClick(e);
      }}
      type="button"
      style={{ color }}
      aria-label={ariaLabel}
    >
      {children}
    </IconButtonWrapper>
  )
);

export default IconButton;
